// extracted by mini-css-extract-plugin
export var pagination = "pagination-module--pagination--2lGIu";
export var move = "pagination-module--move--3vX42";
export var active = "pagination-module--active--10WXz";